/* global $ */

const $responsiveTables = $('.js-responsive-tables');

const responsiveTable = {
  initialize() {
    if ($responsiveTables.length) {
      this.wrapTables();
    }
  },

  wrapTables() {
    $responsiveTables.each((index, element) => {
      const $table = $(element).find('table');

      if ($table.length) {
        $table.wrap('<div class="responsive-table"></div>');
      }
    });
  },
};

export default responsiveTable;
